/* eslint-disable no-await-in-loop */
import { call, put } from 'redux-saga/effects'
import _ from 'lodash'
import Prototypes from '../prototypes'
import firebase from '../config/firebase'
import DriverIncentiveActions from '../reducers/driverIncentiveReducer'

const getDriverActivities = async (driverUid, startFrom, endAt) => {
  const ref = firebase
    .database()
    .ref(`muuver_activities/${driverUid}`)
    .orderByChild('created_at')
    .startAt(startFrom)
    .endAt(endAt)

  const snapshot = await ref.once('value')
  const activities = snapshot.val() || {}

  return Object.values(activities)
}

const getDriverOrders = async (driverUid, startFrom, endAt) => {
  const ref = firebase
    .database()
    .ref(`deliverer_orders/${driverUid}`)
    .orderByChild('created_at')
    .startAt(startFrom)
    .endAt(endAt)

  const snapshot = await ref.once('value')
  const orders = snapshot.val() || {}

  return Object.values(orders)
}

export function* syncDriversBySegment({ driverSegment, startFrom, endAt }) {
  const dbRef = firebase
    .database()
    .ref('deliverers')
    .orderByChild('driver_segment')
    .equalTo(driverSegment.id)

  try {
    yield put(DriverIncentiveActions.setDriverLoading(true))

    const snapshots = yield call([dbRef, dbRef.once], 'value')
    const dates = Prototypes.Driver.getDatesFromDateRange(startFrom, endAt)
    const driverIncentives = {}
    const drivers = snapshots.val() || {}
    const driverKeys = Object.keys(drivers)

    for (let index = 0; index < driverKeys.length; index += 1) {
      const driverKey = driverKeys[index];
      const driver = drivers[driverKey]

      const activities = yield call(getDriverActivities, driverKey, startFrom, endAt)
      const orders = yield call(getDriverOrders, driverKey, startFrom, endAt)
      const performances = Prototypes.Driver.getPerformances({ dates, orders, activities })

      const incentives = Prototypes.DriverIncentive.calculateIncentive(driverSegment.name, performances)

      driverIncentives[driverKey] = {
        ...driver,
        incentives,
        performances,
        totalIncentive: _.sumBy(incentives, 'incentive')
      }
    }

    yield put(DriverIncentiveActions.setDriverIncentives(driverIncentives))
  } catch (error) {
    // eslint-disable-next-line no-alert
    alert(error)
    yield put(DriverIncentiveActions.setDriverLoading(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/driverIncentiveSaga.js